module.exports = "<!-- ko foreach: list.items -->\n<product-list-item params=\"product: $data\" data-bind=\"css: {selected: isSelected, favorite: isFavorite}\"></product-list-item>\n<!-- /ko -->"


//////////////////
// WEBPACK FOOTER
// ./modules/shop/catalog/templates/product-list.html
// module id = wD1/
// module chunks = 8 9